import { usePriceBreakdown } from '../../../../../../api/useSupplierReconciliation/usePriceBreakdown'
import { PriceBreakdownContent } from './components/PriceBreakdownContent'
import { Drawer } from 'antd'
import type React from 'react'
import type { MatchDetailResponse } from '../../../../../../api/useSupplierReconciliation/useMatchDetail'

interface PriceBreakdownDrawerProps {
  setIsPriceBreakdownDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>
  isPriceBreakdownDrawerOpen: boolean
  selectedPriceId: string | null
  setSelectedPriceId?: React.Dispatch<React.SetStateAction<string | null>>
  matchDetails?: MatchDetailResponse
}
export function PriceBreakdownDrawer({
  setIsPriceBreakdownDrawerOpen,
  isPriceBreakdownDrawerOpen,
  selectedPriceId,
  setSelectedPriceId,
  matchDetails,
}: PriceBreakdownDrawerProps) {
  const { getPriceBreakdownById } = usePriceBreakdown()
  const { data, isFetching } = getPriceBreakdownById(selectedPriceId)

  const closeAndClearSelection = () => {
    setIsPriceBreakdownDrawerOpen(false)
    setSelectedPriceId?.(null)
  }
  return (
    <Drawer
      className='quoteBook-drawer'
      title={`Price Breakdown (${data?.source ?? ''})`}
      placement='right'
      onClose={closeAndClearSelection}
      size='large'
      open={isPriceBreakdownDrawerOpen}
    >
      <PriceBreakdownContent isFetchingData={isFetching} data={data} matchDetails={matchDetails} />
    </Drawer>
  )
}
